import { Box, convertHexToRGBA, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { LinearGradientContainer } from '../../comps/LinearGradient'
import { SvgImage } from '../../comps/SvgImages'
import { isMobileWidth } from '../../util/util'

const renderItem = ({ item, index, isMob }) => {
  return (
    <LinearGradientContainer
      colorArray={[convertHexToRGBA('#D1E2FF', 40), convertHexToRGBA('#F1E5FF', 40)]}
      useAngle
      angle={117}
      customStyle={{
        borderRadius: 100,
        paddingHorizontal: isMob ? 24 : 32,
        paddingVertical: isMob ? 16 : 24,
        marginLeft: isMob ? undefined : 12,
        marginRight: isMob ? 8 : 12,
        marginVertical: isMob ? 4 : 12,
      }}>
      <Text
        title={item?.value}
        fontFamily={isMob ? 'jiotype-medium' : 'jiotype-bold'}
        fontSize={isMob ? 12 : 14}
        lineHeight={23}
        color={'BLACK_21'}
      />
    </LinearGradientContainer>
  )
}
export const WelcomeBizzOwners = () => {
  const viewportWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewportWidth)
  return (
    <>
      <Box w={isMob ? '100%' : '50vw'} alignSelf={'center'} justify={'center'}>
        <Box align={'center'}>
          <SvgImage
            imageName={isMob ? 'WelcomeAllBizzMobile' : 'WelcomeAllBizz'}
            width={isMob ? 291 : 500}
            height={isMob ? 104 : 152}
          />
        </Box>
        <Spacer direction={'vertical'} size={isMob ? 44 : 48} />
        <Text
          title={'Welcoming business owners of all types'}
          fontFamily={'jiotype-black'}
          fontSize={isMob ? 24 : 48}
          lineHeight={isMob ? 36 : 64}
          textAlign={isMob ? 'left' : 'center'}
        />
        <Spacer direction={'vertical'} size={isMob ? 24 : 30} />
      </Box>
      <Box
        justify={isMob ? 'flex-start' : 'center'}
        flexDirection={'row'}
        flexWrap={'wrap'}
        w={isMob ? '100%' : '82%'}
        alignSelf={'center'}>
        {allBusinessTypes?.map((item, index) => renderItem({ item, index, isMob }))}
      </Box>
    </>
  )
}

const allBusinessTypes = [
  {
    id: 1,
    value: 'Platforms',
  },
  {
    id: 2,
    value: 'Plugin Builders',
  },
  {
    id: 3,
    value: 'Saas Providers',
  },
  {
    id: 4,
    value: 'Developers',
  },
  {
    id: 5,
    value: 'Agencies',
  },
  {
    id: 6,
    value: 'Bloggers',
  },
  {
    id: 7,
    value: 'Freelancers',
  },
  {
    id: 8,
    value: 'Software Companies',
  },
  {
    id: 9,
    value: 'Publishers',
  },
  {
    id: 10,
    value: 'Influencers',
  },
]
